import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AlertaService } from '../../../services/alerta.service';
import { tableModel } from '../../../components/table/model/tableModel';
import { FilterVariableCatalog } from '../../../models/filters/filter-variable-catalog';
import { VariableCatalogService } from '../../../services/variable-catalog.service';

@Component({
  selector: 'app-variable',
  standalone: false,
  templateUrl: './variable.component.html',
  styleUrl: './variable.component.css'
})
export class VariableComponent {

  @ViewChild(TableComponent) variablesCatalogTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'},
      {columnName:'Codigo',columnValue:'attribute'},
      {columnName:'Tipo Beneficio',columnValue:'variableTypeDes'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterVariableCatalog: FilterVariableCatalog = new FilterVariableCatalog;
  advancedSearch: boolean = false;
  
  private variableCatalogService = inject(VariableCatalogService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterVariableCatalog = new FilterVariableCatalog();
    this.searchVariableGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchVariableGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/variablesCatalog/edit', event.id]);
  }
  addNewVariableGroup(){
    this.router.navigate(['/variablesCatalog/edit', 0]);
  }

  searchVariableGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchVariableGroupPaginator();
  }

  searchVariableGroupPaginator(){
    this.loading = true;

    this.variableCatalogService.findAllPageableVariableCatalog(this.filterVariableCatalog, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.variablesCatalogTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
